import React from 'react';
import {FormattedMessage} from 'react-intl';
import messages from '../../../../res/translations/messages';

const BooleanFormatter = ({value}) => (
    value ? <FormattedMessage {...messages.boolean.true} /> : <FormattedMessage {...messages.boolean.false} />
);

export default BooleanFormatter;
